export default "__VITE_ASSET__DFFX__Fc__"